import { LocationNumbersService } from "../../../services";

const getLocationData = async function ({ commit, dispatch, state }, config) {
    const { locationId } = config

    try {
        const data = await LocationNumbersService.getLocationData(locationId);
        return data;
    } catch (error) {
        throw error;
    }
};

export default getLocationData;
